import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpHelperService } from '../http-helper.service';
@Component({
  selector: 'app-cars',
  templateUrl: './cars.component.html',
  styleUrls: ['./cars.component.css']
})
export class CarsComponent implements OnInit {


  public searchList: any = ['vehicleModel', 'vehicleId'];
  public sortColumn: any = 'status';
  public sortType: boolean = true;
  public loading: boolean = false;
  public sendNotification: boolean = true;
  public message: string = '';
  public selectedCar: any = {};

  constructor(public service: AmbitService,
    public httpHelper: HttpHelperService,
    public toaster: ToastrService,
    public router: Router) {
    if (this.service.adminUser.userAccess.vehicles == 'None') {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit() { }

  getDriverInfo(uid) {
    var name = '', user = this.service.driversList.find(x => x.uid === uid);
    if (user && user.email) {
      name = "<span>" + user.userName || '' + ' <br/> ' + user.email + "</span>";
    }
    return name;
  }

  toggleSortValue(val) {
    if (this.sortColumn == val) {
      this.sortType = !this.sortType;
    } else {
      this.sortColumn = val;
    }
  }

  selectCarClick(car: any) {
    this.selectedCar = JSON.parse(JSON.stringify(car));
    this.sendNotification = true;
    this.message = 'Your vehicle status is updated to '
  }

  updateCarStatus(status) {
    var self = this, updateData: any = {};
    self.loading = true;
    updateData['Vehicles/' + self.selectedCar.carId + '/status'] = status;
    updateData['Vehicles/' + self.selectedCar.carId + '/vehicleCategory'] = self.selectedCar.vehicleCategory;

    firebase.database().ref().update(updateData).then(() => {
      var idx = self.service.carList.findIndex(ob => ob['carId'] === self.selectedCar.carId);
      if (idx >= 0) {
        if (!self.service.carList[idx].status || self.service.carList[idx].status == 'Pending') { self.service.pendigCarsCount--; }
        self.selectedCar.status = status;
        self.service.carList[idx] = JSON.parse(JSON.stringify(self.selectedCar));
      }

      var notifyData: any = { title: 'Orbit Vehicle Status Is Updated', message: ' ' + self.message }
      var user = self.service.allUsersList.find(x => x.uid == self.selectedCar.uid);
      if (user && user.email) {
        self.httpHelper.sendEmailNotifications([user.email], notifyData)
        if (self.sendNotification) { self.service.sendUserNotification(user, notifyData) }
      }

      self.toaster.success('Vehicle success updated successfully.');
      self.loading = false;
      document.getElementById('closeCarMd').click();
    }).catch((err) => {
      self.loading = false;
      self.toaster.error(err.message, '', { timeOut: 3500 });
    });
  }

}